// import { Link } from "react-router-dom";

// export function Services() {
//   const services = [
//     {
//       title: "Expert Diagnostics & Repair",
//       description:
//         "Our certified technicians quickly diagnose and fix issues with laptops, desktops, and more.",
//       img: "https://images.unsplash.com/photo-1642229408339-572fa3328d10?q=80&w=1073&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//       alt: "Diagnostics & Repair",
//     },
//     {
//       title: "Performance Upgrades",
//       description:
//         "Boost your system's speed with RAM, SSD, and graphics card upgrades tailored to your needs.",
//       img: "https://images.unsplash.com/photo-1518770660439-4636190af475",
//       alt: "Performance Upgrades",
//     },
//     {
//       title: "Virus & Malware Removal",
//       description:
//         "We clean and protect your devices from viruses, spyware, and other malicious software.",
//       img: "https://plus.unsplash.com/premium_photo-1682145730713-34bba6d3d14a?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//       alt: "Virus & Malware Removal",
//     },
//     {
//       title: "Data Recovery & Backup MEC",
//       description:
//         "Professional services to recover lost files and set up reliable backup solutions.",
//       img: "https://images.unsplash.com/photo-1666875758412-5957b60d7969?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//       alt: "Data Recovery & Backup",
//     },
//     {
//       title: "Custom PC Builds",
//       description:
//         "We build powerful, custom computers for gaming, video editing, and professional work.",
//       img: "https://images.unsplash.com/photo-1518770660439-4636190af475",
//       alt: "Custom PC Builds",
//     },
//     {
//       title: "Accessories & Peripherals",
//       description:
//         "Browse our inventory of keyboards, mice, monitors, cables, and more to complete your setup.",
//       img: "https://images.unsplash.com/photo-1642229408339-572fa3328d10?q=80&w=1073&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//       alt: "Accessories & Peripherals",
//     },
//   ];

//   // return (
//   //   <section id="services" className="py-12 px-4 bg-gray-50">
//   //     <h3 className="text-2xl md:text-3xl font-bold text-center mb-10">
//   //       Our Services
//   //     </h3>
//   //     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
//   //       {services.map((service, index) => (
//   //         <div
//   //           key={index}
//   //           className="bg-white p-5 md:p-6 rounded-xl shadow-md border-t-4 border-blue-500 hover:shadow-lg transition duration-300 transform hover:-translate-y-1"
//   //         >
//   //           <div className="flex justify-center items-center h-32 w-32 mx-auto mb-4 bg-blue-100 rounded-full overflow-hidden">
//   //             <img
//   //               src={service.img}
//   //               alt={service.alt}
//   //               className="h-full w-full object-cover"
//   //             />
//   //           </div>

//   //           <h4 className="text-lg md:text-xl font-semibold text-center mb-2">
//   //             {service.title}
//   //           </h4>
//   //           <p className="text-sm md:text-base text-gray-600 text-center">
//   //             {service.description}
//   //           </p>
//   //         </div>
//   //       ))}
//   //     </div>
//   //   </section>
//   // );

//   // return (
//   //   <section id="services" className="py-12 px-4 bg-gray-50">
//   //     <h3 className="text-2xl md:text-3xl font-bold text-center mb-10">
//   //       Our Services
//   //     </h3>
//   //     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
//   //       {services.map((service, index) => (
//   //         <div
//   //           key={index}
//   //           className="bg-white p-5 md:p-6 rounded-xl shadow-md border-t-4 border-blue-500 hover:shadow-lg transition duration-300 transform hover:-translate-y-1"
//   //         >
//   //           <div className="flex justify-center items-center h-32 w-32 mx-auto mb-4 bg-blue-100 rounded-full overflow-hidden">
//   //             <img
//   //               src={service.img}
//   //               alt={service.alt}
//   //               className="h-full w-full object-cover"
//   //             />
//   //           </div>
//   //           <h4 className="text-lg md:text-xl font-semibold text-center mb-2">
//   //             {service.title}
//   //           </h4>
//   //           <p className="text-sm md:text-base text-gray-600 text-center">
//   //             {service.description}
//   //           </p>
//   //         </div>
//   //       ))}
//   //     </div>

//   //     {/* Button to navigate */}
//   //     <div className="text-center mt-10">
//   //       <Link
//   //         to="/all-services"
//   //         className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition"
//   //       >
//   //         View All Services
//   //       </Link>
//   //     </div>
//   //   </section>
//   // );

//   // return (
//   //   <section id="services" className="py-12 px-4 bg-gray-50">
//   //     <h3 className="text-2xl md:text-3xl font-bold text-center mb-10">
//   //       Our Services
//   //     </h3>
//   //     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-4xl mx-auto">
//   //       {services.map((service, index) => (
//   //         <div
//   //           key={index}
//   //           className="bg-white p-4 rounded-xl shadow-md border-t-2 border-blue-500 hover:shadow-lg transition duration-300 transform hover:-translate-y-1"
//   //         >
//   //           <div className="flex justify-center items-center h-20 w-20 mx-auto mb-3 bg-blue-100 rounded-full overflow-hidden">
//   //             <img
//   //               src={service.img}
//   //               alt={service.alt}
//   //               className="h-full w-full object-cover"
//   //             />
//   //           </div>
//   //           <h4 className="text-base md:text-lg font-semibold text-center mb-1">
//   //             {service.title}
//   //           </h4>
//   //           <p className="text-xs md:text-sm text-gray-600 text-center">
//   //             {service.description}
//   //           </p>
//   //         </div>
//   //       ))}
//   //     </div>

//   //     {/* Button to navigate */}
//   //     <div className="text-center mt-10">
//   //       <Link
//   //         to="/all-services"
//   //         className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition"
//   //       >
//   //         View All Services
//   //       </Link>
//   //     </div>
//   //   </section>
//   // );

//   return (
//     <section id="services" className="py-12 px-4 bg-gray-50">
//       <h3 className="text-2xl md:text-3xl font-bold text-center mb-10">
//         Our Services
//       </h3>
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-4xl mx-auto">
//         {services.map((service, index) => (
//           <div
//             key={index}
//             className="bg-white p-4 rounded-xl shadow-md border-t-2 border-blue-500 hover:shadow-lg transition duration-300 transform hover:-translate-y-1"
//           >
//             <div className="flex justify-center items-center h-24 w-24 mx-auto mb-3 bg-blue-100 rounded-md overflow-hidden">
//               <img
//                 src={service.img}
//                 alt={service.alt}
//                 className="h-full w-full object-cover"
//               />
//             </div>
//             <h4 className="text-base md:text-lg font-semibold text-center mb-1">
//               {service.title}
//             </h4>
//             <p className="text-xs md:text-sm text-gray-600 text-center">
//               {service.description}
//             </p>
//           </div>
//         ))}
//       </div>

//       {/* Button to navigate */}
//       <div className="text-center mt-10">
//         <Link
//           to="/all-services"
//           className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition"
//         >
//           View All Services
//         </Link>
//       </div>
//     </section>
//   );
// }

// Services.tsx
import React from "react";
import { Link } from "react-router-dom";
import {
  FaLaptop,
  FaNetworkWired,
  FaServer,
  FaCode,
  FaGlobe,
  FaClipboardList,
  FaPenFancy,
  FaPrint,
  FaArrowRight,
} from "react-icons/fa";

export function Services() {
  const kevmarkServices = [
    {
      title: "Preventive Maintenance & Repair",
      description:
        "IT troubleshooting, diagnostics, and repair for laptops, desktops, printers, and more.",
      icon: <FaLaptop className="w-8 h-8 text-blue-600" />,
      img: "https://www.techly.com/media/catalog/product/2/0/20-56_2.jpg",
      alt: "IT Repair & Diagnostics",
    },
    {
      title: "Networking & Cabling",
      description:
        "Design, supply, and installation of LAN, power, voice, and data cabling systems.",
      icon: <FaNetworkWired className="w-8 h-8 text-indigo-600" />,
      img: "https://media.startech.com/cms/products/gallery_large/n6patch15bl10pk.main.jpg",
      alt: "LAN & Data Cabling",
    },
    {
      title: "Hardware Supply & Install",
      description:
        "Servers, desktops, printers, CCTV, UPS, access control systems – supply & setup.",
      icon: <FaServer className="w-8 h-8 text-teal-600" />,
      img: "https://www.rbs-usa.com/img/uploads/image/All-hardware.png",
      alt: "Hardware Supply",
    },
    {
      title: "Software & Training",
      description:
        "Software supply, installation, integration, user training, and ongoing support.",
      icon: <FaCode className="w-8 h-8 text-green-600" />,
      img: "https://images.unsplash.com/photo-1517180102446-f3ece451e9d8?auto=format&fit=crop&w=800&q=80",
      alt: "Software Installation",
    },
    {
      title: "Website Design & Hosting",
      description:
        "Custom website design, domain registration, hosting, and maintenance.",
      icon: <FaGlobe className="w-8 h-8 text-purple-600" />,
      img: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800&q=80",
      alt: "Website Design",
    },
    {
      title: "Stationery & Office Supplies",
      description:
        "Paper, inks, toners, pens, notebooks, filing – everything at great prices.",
      icon: <FaClipboardList className="w-8 h-8 text-orange-600" />,
      img: "https://m.media-amazon.com/images/I/81K5l37CaGL.jpg",
      alt: "Stationery Supplies",
    },
    {
      title: "Branding & Design",
      description:
        "Logo design, business cards, banners – custom branding for SMEs and corporates.",
      icon: <FaPenFancy className="w-8 h-8 text-pink-600" />,
      img: "https://media.licdn.com/dms/image/v2/D4E12AQE5h7fOUJoqnQ/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1690827620760?e=2147483647&t=-fWaTqvuEGfAllY3HAgLAEpPhjMWKH_zMLdps3IzZfM&v=beta",
      alt: "Branding Materials",
    },
    {
      title: "Industrial Printing",
      description:
        "Flyers, brochures, posters, books – e-commerce platform + 5% sponsor discount.",
      icon: <FaPrint className="w-8 h-8 text-red-600" />,
      img: "https://image.made-in-china.com/2f0j00odjthYMCySqO/3-2m-Advertisement-PVC-Banner-Large-Format-Printer.webp",
      alt: "Industrial Printing",
    },
  ];

  return (
    <section
      id="services"
      className="relative py-16 px-6 overflow-hidden bg-gradient-to-b from-white via-gray-50 to-white"
    >
      {/* === SMOOTH BACKGROUND (Same as Products) === */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-purple-50" />
        <div className="absolute top-10 left-10 w-96 h-96 bg-blue-300 rounded-full filter blur-3xl opacity-20 animate-pulse" />
        <div className="absolute top-32 right-20 w-80 h-80 bg-purple-300 rounded-full filter blur-3xl opacity-15 animate-pulse delay-700" />
        <div className="absolute bottom-20 left-32 w-72 h-72 bg-teal-300 rounded-full filter blur-3xl opacity-10 animate-pulse delay-1000" />
        <div className="absolute bottom-10 right-40 w-64 h-64 bg-pink-300 rounded-full filter blur-3xl opacity-10 animate-pulse delay-300" />
        <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-white to-transparent" />
      </div>

      {/* === CONTENT === */}
      <div className="relative z-10">
        {/* Section Title */}
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            Our Core Services
          </h2>
          <p className="mt-3 text-lg text-gray-600 max-w-2xl mx-auto">
            One trusted partner for all your technology & creative needs — since
            2008.
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {kevmarkServices.map((svc, idx) => (
            <div
              key={idx}
              className="group bg-white/80 backdrop-blur-sm rounded-xl shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden border border-white/50"
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={svc.img}
                  alt={svc.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>

              {/* Card Body */}
              <div className="p-6 text-center">
                <div className="flex justify-center mb-4">{svc.icon}</div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {svc.title}
                </h3>
                <p className="text-sm text-gray-600">{svc.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center mt-12">
          <Link
            to="/all-services"
            className="inline-flex items-center gap-2 bg-blue-700 text-white px-7 py-3.5 rounded-lg font-semibold shadow hover:bg-blue-800 hover:shadow-lg transition"
          >
            View All Services
            <FaArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
// // Services.tsx
// import React from "react";
// import { Link } from "react-router-dom";
// import {
//   FaLaptop,
//   FaPrint,
//   FaPenFancy,
//   FaClipboardList,
//   FaArrowRight,
// } from "react-icons/fa";

// export function Services() {
//   const kevmarkServices = [
//     {
//       title: "ICT Solutions",
//       description:
//         "Hardware supply, networking, software installation, website design, hosting & maintenance.",
//       icon: <FaLaptop className="w-8 h-8 text-blue-600" />,
//       img: "https://st4.depositphotos.com/18433260/21497/i/450/depositphotos_214976846-stock-photo-ict-information-communications-technology-concept.jpg",
//       alt: "ICT Solutions",
//     },
//     {
//       title: "Stationery",
//       description:
//         "Office supplies, scholastic materials, toners, consumables – everything your business needs.",
//       icon: <FaClipboardList className="w-8 h-8 text-green-600" />,
//       img: "https://images.openai.com/static-rsc-1/5nEBhnBxcRM2svPBiyb_BlYYs4IU1VO_SrGPmHLbE4DG-S__oKWOlLyZeTL9bBnLg8rEP-g8ZRHf6NsvcDrXmN4YmdWiiVsD4q8HaCaXx2jLv6QzEc_Q5gA0Sgk88JMm6rtowIRfZCzdNR97sLToPA",
//       alt: "Stationery",
//     },
//     {
//       title: "Branding",
//       description:
//         "Graphic design, logo creation, marketing materials – we bring your brand to life.",
//       icon: <FaPenFancy className="w-8 h-8 text-purple-600" />,
//       img: "https://cdn.vectorstock.com/i/500p/82/95/corporate-branding-mockup-set-vector-4298295.jpg",
//       alt: "Branding",
//     },
//     {
//       title: "Printing",
//       description:
//         "High‑quality industrial printing, competitive prices, e‑commerce platform & 5% sponsor discount.",
//       icon: <FaPrint className="w-8 h-8 text-red-600" />,
//       img: "https://images.unsplash.com/photo-1503694978374-8a2fa686963a?fm=jpg&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cHJpbnRpbmclMjBtYWNoaW5lfGVufDB8fDB8fHww&ixlib=rb-4.1.0&q=60&w=3000",
//       alt: "Printing",
//     },
//   ];

//   return (
//     <section id="services" className="py-16 px-6 bg-gray-50">
//       {/* Section Title */}
//       <div className="text-center mb-12">
//         <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
//           Our Core Services
//         </h2>
//         <p className="mt-3 text-lg text-gray-600">
//           One trusted partner for all your technology & creative needs.
//         </p>
//       </div>

//       {/* Service Cards */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
//         {kevmarkServices.map((svc, idx) => (
//           <div
//             key={idx}
//             className="group bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
//           >
//             {/* Image */}
//             <div className="relative h-48 overflow-hidden">
//               <img
//                 src={svc.img}
//                 alt={svc.alt}
//                 className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
//             </div>

//             {/* Card Body */}
//             <div className="p-6 text-center">
//               <div className="flex justify-center mb-4">{svc.icon}</div>
//               <h3 className="text-xl font-semibold text-gray-800 mb-2">
//                 {svc.title}
//               </h3>
//               <p className="text-sm text-gray-600">{svc.description}</p>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* CTA Button */}
//       <div className="text-center mt-12">
//         <Link
//           to="/all-services"
//           className="inline-flex items-center gap-2 bg-blue-700 text-white px-6 py-3 rounded-lg font-medium shadow hover:bg-blue-800 hover:shadow-lg transition"
//         >
//           View All Services
//           <FaArrowRight className="w-4 h-4" />
//         </Link>
//       </div>
//     </section>
//   );
// }
